export const GET_UPCOMING_SALES = `
  query getUpcomingSales {
    getUpcomingSales {
      id
      name
      slug
      on_sale
      owner {
        company_name
      }
    }
  }
`

export const GET_PRODUCTS_BY_SLUG = `
  query getProductsBySlug($slug: String!, $pricing: Boolean) {
    getProductsBySlug(slug: $slug, pricing: $pricing) {
      id
      name
      slug
      image_url
      on_sale
      sold_out
      raffle_is_live
      raffle_minutes
      price_per_unit
      description
      max_quantity
      allow_proxy
      dynamic_quantities
      owner {
        id
        stripe_user_id
        email
        company_name
      }
      pricing { 
        quantity
        total
        fees
        taxes
        addons {
          id
          total
          fees
          taxes
        }
      }
      addons {
        id
        name
        price_per_unit
        sold_out
      }
    }
  }
`